export default function mapPopUpTable(f) {
  let h = '';
  let p = f.properties;
  for (let k in p) {
    if (k === 'asset') {
      // console.log(k, p);
      h += '<b>' + p[k] + '<br/>';
    }
  }
  return '<p>' + h + '</p>';
}
